import Info from "../../pages/index/album/config/Info";
import Startup from "../../pages/index/album/config/Startup";
import Banner from "../../pages/index/album/config/Banner";
import FlowPolicy from "../../pages/index/album/config/FlowPolicy";
import Function from "../../pages/index/album/config/Function";
import Watermark from "../../pages/index/album/config/Watermark";
import Share from "../../pages/index/album/config/Share";
import Advert from "../../pages/index/album/config/Advert";
import Naming from "../../pages/index/album/config/Naming";
import Member from "../../pages/index/album/config/Member";
import Secret from "../../pages/index/album/config/Secret";
import Market from "../../pages/index/album/config/Market";
import Intro from "../../pages/index/album/config/Intro";

export default [
   {
      path: "",
      name: "Album.Config.Default",
      redirect: {name: "Album.Config.Info"}
   },
   {
      name: "Album.Config.Info",
      path: "info",
      component: Info,
      meta: {title: "基础信息", icon: "profile"},
   },
   {
      name: "Album.Config.Intro",
      path: "intro",
      component: Intro,
      meta: {title: "活动详情", icon: "book"},
   },
   {
      name: "Album.Config.Startup",
      path: "startup",
      component: Startup,
      meta: {title: "封面图片", icon: "windows"},
   },
   {
      name: "Album.Config.Banner",
      path: "banner",
      component: Banner,
      meta: {title: "头栏图片", icon: "bars"},
   },
   {
      name: "Album.Config.FlowPolicy",
      path: "flow_policy",
      component: FlowPolicy,
      meta: {title: "上传配置", icon: "cloud-upload"},
   },
   {
      name: "Album.Config.Function",
      path: "function",
      component: Function,
      meta: {title: "人脸&号码", icon: "scan"},
   },
   {
      name: "Album.Config.Watermark",
      path: "watermark",
      component: Watermark,
      meta: {title: "水印配置", icon: "copyright"},
   },
   {
      name: "Album.Config.Share",
      path: "share",
      component: Share,
      meta: {title: "分享配置", icon: "share-alt"},
   },
   {
      name: "Album.Config.Secret",
      path: "secret",
      component: Secret,
      meta: {title: "安全配置", icon: "lock"},
   },
   {
      name: "Album.Config.Advert",
      path: "advert",
      component: Advert,
      meta: {title: "营销推广", icon: "pushpin"}
   },
   {
      name: "Album.Config.Naming",
      path: "nameing",
      component: Naming,
      meta: {title: "冠名露出", icon: "crown"}
   },
   {
      name: "Album.Config.Market",
      path: "market",
      component: Market,
      meta: {title: "照片付费", icon: "pay-circle"}
   },
   {
      name: "Album.Config.Member",
      path: "member",
      component: Member,
      meta: {title: "成员管理", icon: "usergroup-add"},
   },
   {
      name: "Album.Config.Photo",
      path: "photo",
      meta: {title: "图片管理", icon: "picture"},
      redirect: {name: "Album.Photo"}
   },
   {
      name: "Album.Config.Statis",
      path: "statis",
      meta: {title: "统计数据", icon: "line-chart"},
      redirect: {name: "Album.Statis"}
   }
];
